import type { NavigateFunction } from "react-router-dom"
import { isSameRoute } from "../../Components/Utilities/Header/helpers"

export const CURRENT_STEP_KEY = "icash:current-step"

export const InstantLoanRoutes = [
  { path: "" },
  { path: "mobile-verification", state: { title: "Mobile phone validation" } },
  { path: "pin-verification", state: { title: "Verify your mobile phone" } },
  {
    path: "personal-details",
    state: { title: "Personal details", step: 1 },
  },
  {
    path: "residential-details",
    state: { title: "Residential details", step: 2 },
  },
  {
    path: "employment-details",
    state: { title: "Employment details", step: 3 },
  },
  {
    path: "income-details",
    state: { title: "Income details", step: 4 },
  },
  //No step 5/6 (financial details and references details have been removed.)
  { path: "banking-details", state: { title: "Validate your bank", step: 5 } },
  { path: "banking-details/search", parent: "banking-details" },
  { path: /banking-details\/(plaid|flinks)\/bank\/w*/i, parent: "banking-details" },
  { path: "review-in-progress", state: { title: "Review in progress" } },
  { path: "payment-verification", state: { title: "Payment verification required" } },
  { path: "loan-preapproved", state: { title: "Loan in review" } },
  { path: "identity-verification", state: { title: "Identity verification" } },
  { path: "identity-verification/verify", parent: "identity-verification" },
  { path: "identity-verification/error", parent: "identity-verification" },
  { path: "identity-verification/success", state: { title: "Loan in review" } },
]

export const goToRouteStep = (navigate: NavigateFunction, step: number) => {
  const route = InstantLoanRoutes.find((tmp) => tmp.state?.step === step)
  if (route) {
    navigate(`/${route.path}`, {
      state: route.state,
    })
  }
}

export const goToRouteIndex = (navigate: NavigateFunction, index: number) => {
  navigate(`/${InstantLoanRoutes[index].path}`, {
    state: InstantLoanRoutes[index].state,
  })
}

export const goToRoutePath = (navigate: NavigateFunction, path: string) => {
  const index = InstantLoanRoutes.findIndex((tmp) => tmp.path === path)
  navigate(`/${InstantLoanRoutes[index].path}`, {
    state: InstantLoanRoutes[index].state,
  })
}

export const goToMobileVerification = (navigate: NavigateFunction) => {
  const route = InstantLoanRoutes.find((tmp) => tmp.path === "mobile-verification")
  if (route) {
    navigate(`/${route.path}`, {
      state: route.state,
    })
  }
}

export const goToPersonalDetails = (navigate: NavigateFunction) => {
  const route = InstantLoanRoutes.find((tmp) => tmp.path === "personal-details")
  if (route) {
    navigate(`/${route.path}`, {
      state: route.state,
    })
  }
}

export const goToBankingDetails = (navigate: NavigateFunction) => {
  const route = InstantLoanRoutes.find((tmp) => tmp.path === "banking-details")
  if (route) {
    navigate(`/${route.path}`, {
      state: route.state,
    })
  }
}

export const goToNext = (navigate: NavigateFunction, path: (typeof InstantLoanRoutes)[number]["path"]) => {
  const currentIndex = InstantLoanRoutes.findIndex((route) => isSameRoute(route.path, path.toString()))

  if (currentIndex === InstantLoanRoutes.length - 1) goToRouteIndex(navigate, 0)
  else goToRouteIndex(navigate, currentIndex + 1)
}

export const canGoToPrevious = (path: (typeof InstantLoanRoutes)[number]["path"]) => {
  const currentIndex = InstantLoanRoutes.findIndex((route) => isSameRoute(route.path, path.toString()))
  if (currentIndex <= 3 || currentIndex >= 11) return false
  return true
}

export const goToPrevious = (navigate: NavigateFunction, path: (typeof InstantLoanRoutes)[number]["path"]) => {
  const currentIndex = InstantLoanRoutes.findIndex((route) => isSameRoute(route.path, path.toString()))

  if (currentIndex === 0) goToRouteIndex(navigate, 0)
  else goToRouteIndex(navigate, currentIndex - 1)
}

export const goToPastStep = (
  navigate: NavigateFunction,
  path: string,
  route: { state?: { step?: number }; path: string | RegExp }
) => {
  const currentRoute = InstantLoanRoutes.find((tmp) => isSameRoute(tmp.path, path))

  if (currentRoute) {
    const routeIndexSelected = InstantLoanRoutes.findIndex((tmp) => isSameRoute(tmp.path, route.path.toString()))

    if (routeIndexSelected === -1) {
      return
    }

    const currentStep = currentRoute.state?.step ?? 0
    const selectedStep = route.state?.step ?? 0
    if (selectedStep < currentStep) {
      goToRouteIndex(navigate, routeIndexSelected)
    }
  }
}

export const goToIdentityVerificationSDK = (navigate: NavigateFunction) => {
  navigate("/identity-verification/verify", {
    state: { title: "Identity verification" },
  })
}

export const goToIdentityVerificationError = (
  navigate: NavigateFunction,
  status: "session_expired" | "camera_access" | "unable_to_load" | "try_again" | "verification_incomplete",
  attemptNumber?: number,
  maxRetryAttempts?: number
) => {
  navigate("/identity-verification/error", {
    state: { title: "Identity verification", status, attemptNumber, maxRetryAttempts },
  })
}

export const goToIdentityVerificationSuccess = (navigate: NavigateFunction) => {
  navigate("/identity-verification/success", {
    state: { title: "Loan in review" },
  })
}
